import { position } from 'src/app/models/position';
import { Component, Inject, Input, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
// import { MouseEvents } from '@agm/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { timeout } from 'rxjs/operators';



@Component({
  selector: 'google-map-pin',
  templateUrl: './google-map-pin.component.html',
  styleUrls: ['./google-map-pin.component.css']
})
export class GoogleMapPinComponent implements OnInit {

  @Output() locationNameResolved = new EventEmitter<any>();

  latitude: number = 51.678418;
  longitude: number = 7.809007;

  mapLatitude: number = 51.678418;
  mapLongitude: number = 7.809007;
  circleCoordinate: position;
  circleLatitude: number = 51.678418;
  circleLongitude: number = 7.809007;
  radiusMeter: number;//In Meter.
  zoom: number = 12;
  location;
  address: string;
  faTimesCircle = faTimesCircle;
  markerDraggable = true;
  private geoCoder;
  oldLongitude: number;
  oldLatitude: number;
  marker: position[] = [];

  constructor(private dialogRef: MatDialogRef<GoogleMapPinComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private cd: ChangeDetectorRef
  ) { }





  ngOnInit() {



    //IF for only view not to edit



    if (this.data != null && this.data.isDraggable != null && this.data.position != null && this.data.circleCoordinate != null) {


      this.markerDraggable = this.data.isDraggable;
      this.circleCoordinate = this.data.circleCoordinate
      this.circleLatitude = this.data.circleCoordinate.lat;
      this.circleLongitude = this.data.circleCoordinate.lng;
      this.latitude = this.data.position.latitude;
      this.longitude = this.data.position.longitude;
      this.marker.push({ lat: this.latitude, lng: this.longitude })
      this.address = this.data.position.address;
      this.radiusMeter = this.KmToMeter(this.data.radius);

    }
    else if (this.data != null && this.data.isDraggable != null && this.data.position != null) {


      this.markerDraggable = this.data.isDraggable;
      //this.circleCoordinate = { lat: this.data.position.latitude, lng: this.data.position.longitude }
      //this.circleLatitude = this.data.position.latitude;
      //this.circleLongitude = this.data.position.longitude;
      this.latitude = this.data.position.latitude;
      this.longitude = this.data.position.longitude;
      this.marker.push({ lat: this.latitude, lng: this.longitude })
      this.address = this.data.position.address

    }
    else if (this.data != null && this.data.circleCoordinate != null) {
      this.circleCoordinate = this.data.circleCoordinate;

      this.setCurrentLocation();
      this.radiusMeter =this.KmToMeter( this.data.radius);
    }
    else {
      //this.geoCoder = new google.maps.Geocoder;
      this.setCurrentLocation();
    }


  }
  KmToMeter(value: any): number {
   return value*1000;
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {

      navigator.geolocation.getCurrentPosition(
        (position) => {



          /* this.circleLatitude = position.coords.latitude;
          this.circleLongitude = position.coords.longitude; */
          if (this.circleCoordinate == null) {
            this.circleCoordinate = { lat: position.coords.latitude, lng: position.coords.longitude }
          }



          let newLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          let circleLatLng = new google.maps.LatLng(this.circleCoordinate.lat, this.circleCoordinate.lng);
          if (this.areLatLngInCircle(newLatLng, circleLatLng,this.radiusMeter)) {
            this.marker.push({ lat: position.coords.latitude, lng: position.coords.longitude });
            this.getAddress(position.coords.latitude, position.coords.longitude);
          }
          else{
            this.marker.push({ lat: this.circleCoordinate.lat, lng: this.circleCoordinate.lng });
            this.getAddress(this.circleCoordinate.lat, this.circleCoordinate.lng);

          }

          // if (!this.arePointInCircle({ lat: position.coords.latitude, lng: position.coords.longitude }, this.circleCoordinate, this.radiusMeter)) {
          //   this.marker.push({ lat: position.coords.latitude, lng: position.coords.longitude });
          //   this.getAddress(position.coords.latitude, position.coords.longitude);

          // }
          // else {
          //   this.marker.push({ lat: this.circleCoordinate.lat, lng: this.circleCoordinate.lng });
          //   this.getAddress(this.circleCoordinate.lat, this.circleCoordinate.lng);

          // }

          this.latitude = this.circleCoordinate.lat;
          this.longitude = this.circleCoordinate.lng;



          this.zoom = 15;
        }, (err) => {
          this.latitude = this.circleCoordinate.lat;
          this.longitude = this.circleCoordinate.lng;
          this.marker.push({ lat: this.circleCoordinate.lat, lng: this.circleCoordinate.lng });
          this.getAddress(this.circleCoordinate.lat, this.circleCoordinate.lng);
        }
      );
    }
  }

  markerDragEnd($event) {

    let newLat = $event.latLng.lat();
    let newLng = $event.latLng.lng();
    let newPosition: position = { lat: newLat, lng: newLng };


    let newLatLng: google.maps.LatLng = new google.maps.LatLng(newLat, newLng);
    let circleLatLng = new google.maps.LatLng(this.circleCoordinate.lat, this.circleCoordinate.lng);
    if (google.maps.geometry.spherical.computeDistanceBetween(newLatLng, circleLatLng) <= this.radiusMeter) {

      this.latitude = $event.latLng.lat();
      this.longitude = $event.latLng.lng();
      this.marker.pop();
      this.marker.push({ lat: this.latitude, lng: this.longitude });

      this.getAddress(this.latitude, this.longitude);
    } else {

      this.longitude = this.circleCoordinate.lng;
      this.latitude = this.circleCoordinate.lat;
      this.marker.pop();
      this.marker.push({ lat: this.circleCoordinate.lng, lng: this.circleCoordinate.lat });
      setTimeout(() => {
        this.marker.pop();
        this.marker.push({ lat: this.circleCoordinate.lat, lng: this.circleCoordinate.lng });
        this.longitude = this.circleCoordinate.lng;
        this.latitude = this.circleCoordinate.lat;
        this.cd.markForCheck();
      }, 100);

    }

  }

  markerDragStart($event) {

    this.oldLongitude = this.longitude;
    this.oldLatitude = this.latitude;
  }

  areLatLngInCircle(newLatLng: google.maps.LatLng, circleLatLng: google.maps.LatLng,radius:number) {


    let res = false;
    if (google.maps.geometry.spherical.computeDistanceBetween(newLatLng, circleLatLng) <= radius) {
      res = true;
    }
    return res;
  }
  getAddress(latitude, longitude) {

    this.geoCoder = new google.maps.Geocoder;
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {



      if (status === 'OK') {
        if (results[0]) {
          //this.zoom = 12;
          this.address = results[0].formatted_address;
          let data = {
            latitude: this.latitude,
            longitude: this.longitude,
            address: this.address
          }
          this.locationNameResolved.emit(data);
        } else {

        }
      } else {

      }

    }, err => {

    });
  }

  close() {
    this.dialogRef.close({
      latitude: this.latitude,
      longitude: this.longitude,
      address: this.address
    });



  }

  // credits to user:69083 for this specific function
  arePointsNear(checkPoint, centerPoint, km): boolean {
    var ky = 40000 / 360;
    var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
    var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
    var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
  }

  arePointInCircle(point: position, circlePoint: position, radiusInMeter) {
    let newLatLng: google.maps.LatLng = new google.maps.LatLng(point.lng, point.lat);
    let circleLatLng: google.maps.LatLng = new google.maps.LatLng(circlePoint.lng, circlePoint.lat);
    if (google.maps.geometry.spherical.computeDistanceBetween(newLatLng, circleLatLng) <= radiusInMeter) {

      return true;
    } else {
      return false;

    }

  }

  test() {
    this.longitude = this.circleCoordinate.lng;
    this.latitude = this.circleCoordinate.lat;
  }
}
